export default __webpack_public_path__ + "static/media/gallery_00.d9ad44f9.jpg";